import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from "react-router-dom";

const FilterBlock = ({ title, query, pathname, name, filters, allLabel }) => (
  <div className="nav-leftpanel--ll-item">
    <div className="nav-leftpanel--ll-link">
      <div>
        <h5>{title}</h5>
      </div>
    </div>
    <div className="nav-leftpanel--ll-link">
      <NavLink
        to={{ pathname, search: query.stringify({ [name]: null }) }}
        activeClassName="active"
        isActive={() => query[name] === undefined}
        >
        {allLabel}
      </NavLink>
    </div>
    {filters.map(filter => (
      <div className="nav-leftpanel--ll-link" key={filter[0]}>
        <NavLink
          to={{ pathname, search: query.stringify({ [name]: filter[0], page: 1 }) }}
          activeClassName="active"
          isActive={() => query[name] === filter[0]}
          >
          {filter[1]}
        </NavLink>
      </div>
    ))}
  </div>
);

FilterBlock.propTypes = {
  title: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  allLabel: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(PropTypes.array).isRequired,
};
FilterBlock.defaultProps = {
  allLabel: 'Wszystkie',
};

export default FilterBlock;


// WEBPACK FOOTER //
// ./src/components/ui/FilterBlock.jsx